<template>
  <div class="couleur-fond align-items-center lobby-table-game-specific-data">
    <b-container class="m-auto d-flex justify-content-center align-items-center">
      <b-row class="m-0 px-1 w-100 h-100">
        <b-col class="d-block justify-content-end p-0">
          <div class="prize overflow-hidden graphik_semibold d-flex align-items-center">
            <CarteInfoSecondaireCEDBlackjack
              v-if="produit.gameTypeUnified == 'blackjack'"
              :seats="produit.seats"
              :bet-behind="produit.betBehind"
              :seats-taken="produit.seatsTaken"
            >
            </CarteInfoSecondaireCEDBlackjack>

            <CarteInfoSecondaireCEDRoulette
              v-else-if="['roulette', 'americanroulette'].includes(produit.gameTypeUnified)"
              :results="produit.results"
              :luckyNumbers="produit.luckyNumbers"
            >
            </CarteInfoSecondaireCEDRoulette>

            <CarteInfoSecondaireCEDBaccarat
              v-else-if="['baccarat', 'dragontiger'].includes(produit.gameTypeUnified)"
              :gameTypeUnified="produit.gameTypeUnified"
              :road="produit.road"
            >
            </CarteInfoSecondaireCEDBaccarat>

            <CarteInfoSecondaireCEDLightningdice
              v-else-if="produit.gameTypeUnified == 'lightningdice'"
              :results="produit.results"
            >
            </CarteInfoSecondaireCEDLightningdice>

            <CarteInfoSecondaireCEDSicbo
              v-else-if="produit.gameTypeUnified == 'sicbo'"
              :results="produit.results"
            >
            </CarteInfoSecondaireCEDSicbo>

            <CarteInfoSecondaireCEDMoneywheel
              v-else-if="produit.gameTypeUnified == 'moneywheel'"
              :results="produit.results"
            >
            </CarteInfoSecondaireCEDMoneywheel>

            <CarteInfoSecondaireCEDMonopoly
              v-else-if="produit.gameTypeUnified == 'monopoly'"
              :results="produit.results"
            >
            </CarteInfoSecondaireCEDMonopoly>

            <CarteInfoSecondaireCEDTopcard
              v-else-if="produit.gameTypeUnified == 'topcard'"
              :history="produit.history"
            >
            </CarteInfoSecondaireCEDTopcard>

            <CarteInfoSecondaireCEDMegaball
              v-else-if="produit.gameTypeUnified == 'megaball'"
              :results="produit.results"
            >
            </CarteInfoSecondaireCEDMegaball>

            <CarteInfoSecondaireCEDCrazyTime
              v-else-if="produit.gameTypeUnified == 'crazytime'"
              :results="produit.results"
            >
            </CarteInfoSecondaireCEDCrazyTime>

            <!-- Poker, dealnodeal, craps, etc ne nécessitent pas d'affichage particulier -->
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import CarteInfoSecondaireCEDBaccarat from '@/components/casino/carte/CarteInfoSecondaireCEDBaccarat';
import CarteInfoSecondaireCEDBlackjack from '@/components/casino/carte/CarteInfoSecondaireCEDBlackjack';
import CarteInfoSecondaireCEDCrazyTime from '@/components/casino/carte/CarteInfoSecondaireCEDCrazyTime';
import CarteInfoSecondaireCEDLightningdice from '@/components/casino/carte/CarteInfoSecondaireCEDLightningdice';
import CarteInfoSecondaireCEDMegaball from '@/components/casino/carte/CarteInfoSecondaireCEDMegaball';
import CarteInfoSecondaireCEDMoneywheel from '@/components/casino/carte/CarteInfoSecondaireCEDMoneywheel';
import CarteInfoSecondaireCEDMonopoly from '@/components/casino/carte/CarteInfoSecondaireCEDMonopoly';
import CarteInfoSecondaireCEDRoulette from '@/components/casino/carte/CarteInfoSecondaireCEDRoulette';
import CarteInfoSecondaireCEDSicbo from '@/components/casino/carte/CarteInfoSecondaireCEDSicbo';
import CarteInfoSecondaireCEDTopcard from '@/components/casino/carte/CarteInfoSecondaireCEDTopcard';

export default {
  name: 'CarteInfoSecondaireCED',
  components: {
    CarteInfoSecondaireCEDBaccarat,
    CarteInfoSecondaireCEDBlackjack,
    CarteInfoSecondaireCEDCrazyTime,
    CarteInfoSecondaireCEDLightningdice,
    CarteInfoSecondaireCEDMegaball,
    CarteInfoSecondaireCEDMoneywheel,
    CarteInfoSecondaireCEDMonopoly,
    CarteInfoSecondaireCEDRoulette,
    CarteInfoSecondaireCEDSicbo,
    CarteInfoSecondaireCEDTopcard,
  },
  props: {
    produit: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.container {
  max-width: none;
}

.couleur-fond {
  background: white;
  bottom: 0;
  width: -webkit-fill-available;
  border-bottom-style: solid;
}
p {
  color: black !important;
}

.container {
  padding: 0 4px;
  height: 2.8rem;
}
</style>
